import { SxProps, Theme } from '@mui/system';

const classes = {
  counterOfferTitle: {
    fontSize: '22px',
    fontWeight: 700,
    color: 'common.grey850',
    marginBottom: '9px',
  },
  customLoadingContainer: {
    position: 'fixed',
    height: '100vh',
    left: 0,
    zIndex: 999,
  },
  counterOfferBtn: {
    backgroundColor: 'common.lightGreen',
    border: 'none',
  },

  counterOfferContainer: {
    mt: '16px',
    mb: '6px',
  },

  padTop: {
    pt: 1.5,
    mt: '16px',
  },
  promoText: {
    fontSize: 13,
    color: 'common.counterRed',
    fontWeight: '500',
  },
  promo: { fontSize: 14, fontWeight: '500' },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
